var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnydeskRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6249 0.847322C7.83416 0.847322 8.03071 0.928653 8.17855 1.07691L14.1729 7.07128C14.4783 7.37669 14.4783 7.87357 14.1729 8.17856L8.17855 14.1734C8.03071 14.3212 7.83416 14.4025 7.6249 14.4025C7.41564 14.4025 7.21909 14.3212 7.07126 14.1734L1.07647 8.17856C0.771058 7.87315 0.771058 7.37627 1.07647 7.07128L7.07126 1.07691C7.21909 0.928653 7.41564 0.847322 7.6249 0.847322ZM7.6249 0.00012207C7.20766 0.00012207 6.79041 0.159396 6.47229 0.477519L0.477503 6.4723C-0.159168 7.10897 -0.159168 8.14086 0.477503 8.77796L6.47186 14.7723C6.79041 15.0904 7.20766 15.2497 7.6249 15.2497C8.04215 15.2497 8.45939 15.0904 8.77752 14.7723L14.7719 8.77796C15.4086 8.14129 15.4086 7.1094 14.7719 6.4723L8.77752 0.477519C8.45939 0.159396 8.04215 0.00012207 7.6249 0.00012207Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8543 6.47229C20.491 7.10896 20.491 8.14085 19.8543 8.77794L13.8596 14.7723C13.2229 15.409 12.191 15.409 11.5539 14.7723L5.55953 8.77752C4.92286 8.14085 4.92286 7.10854 5.55953 6.47186L11.5543 0.477503C12.191 -0.159168 13.2229 -0.159168 13.86 0.477503L19.8543 6.47229Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnydeskRedIcon);
export default __webpack_public_path__ + "static/media/anydesk_red_icon.fd1fbf46993401edf58a715b94a2d44d.svg";
export { ForwardRef as ReactComponent };